module.exports = __webpack_public_path__ + "img/d2.0cf09e9b.jpg";